<script lang="ts">
  /** The path to a commitment. Locked: the state of each step is computed from
   *  evidence, so editing the words here would make the path disagree with it. */
  import type { BlockSteps } from './types';

  let { block }: { block: BlockSteps } = $props();
  const now = $derived(block.items.findIndex(step => step.state === 'now'));
  const label = $derived(now >= 0
    ? `Path to a commitment, step ${now + 1} of ${block.items.length}`
    : `Path to a commitment, ${block.items.length} steps`);
</script>

<ol class="brf-path" aria-label={label}>
  {#each block.items as step, i (i)}
    <li class={step.state} aria-current={step.state === 'now' ? 'step' : undefined}>
      <span class="n">{i + 1}</span>
      <span class="l">{step.label}</span>
      {#if step.date}<span class="d" data-emphasis={step.emphasis}>{step.date}</span>{/if}
    </li>
  {/each}
</ol>
